import {
  uaVersionListConstants,
  uaVersionUploadConstants,
  uaVersionDeleteConstants,
  uaVersionConstants,
} from "../_redux-constants";
import { uaVersionListService } from "../../_services";

function getUAVersionList(queryParams) {
  function getUAVersionListLoad() {
    return { type: uaVersionListConstants.UA_VERSION_LIST_LOADING };
  }
  function uaVersionListSuccess(data) {
    return { type: uaVersionListConstants.UA_VERSION_LIST_SUCCESS, data };
  }
  function uaVersionListFailure(error) {
    return { type: uaVersionListConstants.UA_VERSION_LIST_FAILURE, error };
  }
  return (dispatch) => {
    dispatch(getUAVersionListLoad());
    return uaVersionListService.getUAVersionList(queryParams).then(
      (data) => {
        dispatch(uaVersionListSuccess(data));
      },
      (error) => {
        dispatch(uaVersionListFailure(error?.toString()));
      }
    );
  };
}

function uploadUAVersion(queryParams) {
  function uaVersionUploadLoad() {
    return { type: uaVersionUploadConstants.UA_VERSION_UPLOAD_LOADING };
  }
  function uaVersionUploadSuccess(data) {
    return { type: uaVersionUploadConstants.UA_VERSION_UPLOAD_SUCCESS, data };
  }
  function uaVersionUploadFailure(error) {
    return { type: uaVersionUploadConstants.UA_VERSION_UPLOAD_FAILURE, error };
  }
  return (dispatch) => {
    dispatch(uaVersionUploadLoad());
    return new Promise((resolve, reject) => {
      uaVersionListService.uploadUAVersion(queryParams).then(
        (data) => {
          dispatch(uaVersionUploadSuccess(data));
          resolve(data);
        },
        (error) => {
          dispatch(uaVersionUploadFailure(error));
          reject(error);
        }
      );
    });
  };
}

function deleteUAVersion(queryParams) {
  function uaVersionDeleteLoad() {
    return { type: uaVersionDeleteConstants.UA_VERSION_DELETE_LOADING };
  }
  function uaVersionDeleteSuccess(data) {
    return { type: uaVersionDeleteConstants.UA_VERSION_DELETE_SUCCESS, data };
  }
  function uaVersionDeleteFailure(error) {
    return { type: uaVersionDeleteConstants.UA_VERSION_DELETE_FAILURE, error };
  }
  return (dispatch) => {
    dispatch(uaVersionDeleteLoad());
    return uaVersionListService.deleteUAVersion(queryParams).then(
      (data) => {
        dispatch(uaVersionDeleteSuccess(data));
      },
      (error) => {
        dispatch(uaVersionDeleteFailure(error?.toString()));
      }
    );
  };
}

function uaVersion(queryParams) {
  function uaVersionLoad() {
    return { type: uaVersionConstants.UA_VERSION_LOADING };
  }
  function uaVersionSuccess(data) {
    return { type: uaVersionConstants.UA_VERSION_SUCCESS, data };
  }
  function uaVersionFailure(error) {
    return { type: uaVersionConstants.UA_VERSION_FAILURE, error };
  }
  return (dispatch) => {
    dispatch(uaVersionLoad());
    return uaVersionListService.showUAVersion(queryParams).then(
      (data) => {
        dispatch(uaVersionSuccess(data));
      },
      (error) => {
        dispatch(uaVersionFailure(error?.toString()));
      }
    );
  };
}

export const uaVersionListActions = {
  getUAVersionList,
  uploadUAVersion,
  deleteUAVersion,
  uaVersion,
};
